import { useState, useEffect } from 'react';

/**
 * Applies theme to the document based on theme preference
 */
const applyTheme = (theme: 'light' | 'dark'): void => {
  if (theme === 'dark') {
    document.documentElement.classList.add('ion-palette-dark');
  } else {
    document.documentElement.classList.remove('ion-palette-dark');
  }
};

/**
 * Hook to manage theme preferences and application
 */
export const useTheme = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Check initial theme on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    const theme = savedTheme === 'dark' || (savedTheme === null && prefersDark) ? 'dark' : 'light';
    setIsDarkMode(theme === 'dark');
    applyTheme(theme);
  }, []);

  const setTheme = (theme: 'light' | 'dark') => {
    setIsDarkMode(theme === 'dark');
    applyTheme(theme);
    localStorage.setItem('theme', theme);
  };

  return { isDarkMode, setTheme };
};

export default useTheme;